import React from 'react';
import { Button } from 'components/shadcn/ui/button';

const DeviceLogsFilters = ({
    startTimeInput,
    setStartTimeInput,
    endTimeInput,
    setEndTimeInput,
    selectedLevels,
    toggleLevel,
    onApply,
    isLoading,
    isApplyDisabled,
}) => {
    return (
        <div className="flex flex-col items-end gap-3 space-y-4 p-5 md:flex-row md:space-y-0">
            <div className="flex w-full flex-col gap-4 sm:flex-row">
                <div className="flex w-full flex-col gap-1">
                    <label className="text-sm font-medium text-foreground">
                        Start Time
                    </label>
                    <input
                        type="datetime-local"
                        value={startTimeInput}
                        onChange={(e) => setStartTimeInput(e.target.value)}
                        className="w-full rounded-md border border-input bg-card px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                    />
                </div>

                <div className="flex w-full flex-col gap-1">
                    <label className="text-sm font-medium text-foreground">
                        End Time
                    </label>
                    <input
                        type="datetime-local"
                        value={endTimeInput}
                        onChange={(e) => setEndTimeInput(e.target.value)}
                        className="w-full rounded-md border border-input bg-card px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                    />
                </div>
            </div>

            <div className="flex w-full sm:w-auto">
                {['alarm', 'fault'].map((level) => (
                    <button
                        key={level}
                        onClick={() => toggleLevel(level)}
                        aria-label={level}
                        className={`flex-1 border border-input px-4 py-2 text-sm font-medium transition-colors first:rounded-l-md last:rounded-r-md sm:flex-none ${
                            selectedLevels.includes(level)
                                ? 'bg-card text-foreground'
                                : 'bg-muted text-muted-foreground hover:bg-card'
                        }`}
                    >
                        {level.charAt(0).toUpperCase() + level.slice(1)}
                    </button>
                ))}
            </div>

            <Button
                variant="outline"
                onClick={onApply}
                disabled={isApplyDisabled || isLoading}
                className="w-full border-border disabled:bg-muted sm:w-[200px]"
            >
                Apply Filters
            </Button>
        </div>
    );
};

export default DeviceLogsFilters;
